import React, { useState, useEffect } from 'react'
import AddRevision from '../components/AddRevisionModal'
import { Icon } from '@iconify/react'
import { useAppSelector, useAppDispatch } from '../../../../redux/hook'
import { getJobInfo } from '../api/index'
import { getLookupValue } from '../utils/index'
import { formatDate } from '../../../resources/empresources/utils/index'
import { setJobInformation } from '../../slice/index'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { JobInfoType } from '../../type'
import { useLocation } from 'react-router-dom'

const Jobinfo: React.FC<{
    lookupValues: any
    userId: string
    isActive: boolean
}> = ({ lookupValues, userId, isActive }) => {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const [showRevisionModal, setShowRevisionModal] = useState<boolean>(false)
    const [jobInfo, setJobInfo] = useState<JobInfoType | null>(null)
    const [addCase, setAddCase] = useState<string>('')
    const { role } = useAppSelector((state) => state.persistedReducers.user)
    const state = useAppSelector((state) => state.jobInfo.jobInfo)
    const params = new URLSearchParams(location.search)
    const otherUserId = params.get('userId')

    useEffect(() => {
        const getJobInformation = async () => {
            try {
                const param = {
                    userId: otherUserId,
                }
                dispatch(SHOW_LOADER())
                const response = await getJobInfo(param)
                setJobInfo(response.data)
                dispatch(setJobInformation(response.data))
            } catch (err) {
                console.error('Error fetching', err)
            } finally {
                dispatch(SHOW_LOADER())
            }
        }
        if (
            (location.pathname === '/profile' ||
                location.pathname === '/users/view') &&
            isActive
        ) {
            getJobInformation()
        }
    }, [lookupValues, otherUserId, isActive])

    useEffect(() => {
        dispatch(SHOW_LOADER())
        setJobInfo(state)
        dispatch(HIDE_LOADER())
    }, [state])
    return (
        <div>
            <AddRevision
                show={showRevisionModal}
                onClose={setShowRevisionModal}
                jobInfo={jobInfo}
                addCase={addCase}
                lookupValues={lookupValues}
                userId={userId}
            />
            <div className="user-form user-job-info">
                {role === 'Admin' && (
                    <div className="dropdown-custom-link">
                        <Icon
                            onClick={() => {
                                setAddCase('Edit')
                                setShowRevisionModal(true)
                            }}
                            icon="bx:edit"
                            className="icon-primary"
                            color="#3d87de"
                            style={{
                                position: 'absolute',
                                right: '0',
                                zIndex: '999',
                            }}
                            cursor={'pointer'}
                        />
                    </div>
                )}

                <div className="prof-info">
                    <div className="row mt-4">
                        <div className="col-sm-4">
                            <div className="form-group mb-4">
                                <label>Job Title</label>
                                <p>{jobInfo?.jobTitle}</p>
                            </div>
                            <div className="form-group mb-4">
                                <label>Salary/Hourly Rate</label>
                                <p>
                                    {jobInfo?.salaryOrHourlyRate
                                        ? `$ ${jobInfo?.salaryOrHourlyRate}`
                                        : '--'}
                                </p>
                            </div>
                            {/* <div className="form-group mb-4">
                                <label>Employee Earns Commission</label>
                                <p>Yes</p>
                            </div> */}
                            <div className="form-group mb-4">
                                <label>Employee Earns Bonus</label>
                                <p>
                                    {jobInfo?.employeeEarnsBonus === true
                                        ? 'Yes'
                                        : 'No'}
                                </p>
                            </div>
                            <div className="form-group mb-4">
                                <label>Yearly Insurable Earnings</label>
                                <p>
                                    {jobInfo?.yearlyInsurableEarning
                                        ? `$ ${jobInfo?.yearlyInsurableEarning}`
                                        : '--'}
                                </p>
                            </div>
                        </div>
                        <div className="col-sm-4">
                            <div className="form-group mb-4">
                                <label>Employment Type</label>
                                <p>
                                    {getLookupValue(
                                        lookupValues,
                                        'EmploymentType',
                                        jobInfo?.employmentTypeId ?? 0
                                    )}
                                </p>
                            </div>
                            <div className="form-group mb-4">
                                <label>Hours Allocated</label>
                                <p>
                                    {jobInfo?.hoursAllocated
                                        ? jobInfo?.hoursAllocated
                                        : '--'}
                                </p>
                            </div>
                            {/* <div className="form-group mb-4">
                                <label>Commission Amount</label>
                                <p>$ 340.00</p>
                            </div> */}
                            <div className="form-group mb-4">
                                <label>Bonus Amount</label>
                                <p>
                                    {jobInfo?.bonusAmount
                                        ? `$ ${jobInfo?.bonusAmount}`
                                        : '--'}
                                </p>
                            </div>
                            <div className="form-group mb-4">
                                <label>Pay Frequency</label>
                                <p>
                                    {getLookupValue(
                                        lookupValues,
                                        'PayFrequency',
                                        jobInfo?.payFrequencyId ?? 0
                                    )}
                                </p>
                            </div>
                        </div>
                    </div>

                    {role === 'Admin' && (
                        <>
                            <div className="row mt-4 mb-4">
                                <div className="d-flex justify-content-between">
                                    <div></div>
                                    <div>
                                        <div className="button-block ">
                                            <a
                                                className="button button-primary"
                                                onClick={() => {
                                                    setAddCase('Add')
                                                    setShowRevisionModal(true)
                                                }}
                                            >
                                                ADD REVISION
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {jobInfo?.revisedJobInfo?.length ? (
                                <div>
                                    <h5>Revised Salaries</h5>
                                    {jobInfo?.revisedJobInfo?.map(
                                        (revision: any, index: number) => (
                                            <div key={index}>
                                                <p className="sal-title">
                                                    As on{' '}
                                                    {formatDate(
                                                        revision.revisionAsOn
                                                    )}
                                                </p>
                                                <div className="row sal-details">
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Employment
                                                                    Type:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {getLookupValue(
                                                                        lookupValues,
                                                                        'EmploymentType',
                                                                        revision.employmentTypeId
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Commission:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {revision.commissionAmout
                                                                        ? `$ ${revision.commissionAmout}`
                                                                        : '--'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Salary/Hourly
                                                                    Rate:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {revision.salaryOrHourlyRate
                                                                        ? `$ ${revision.salaryOrHourlyRate}`
                                                                        : '--'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Earns Bonus:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {revision.employeeEarnsBonus
                                                                        ? 'Yes'
                                                                        : 'No'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Hours
                                                                    Allocated:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {revision.hoursAllocated
                                                                        ? revision.hoursAllocated
                                                                        : '--'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Bonus:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {revision.bonusAmount
                                                                        ? `$ ${revision.bonusAmount}`
                                                                        : '--'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Earns
                                                                    Commission:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {revision.employeeEarnsCommision
                                                                        ? 'Yes'
                                                                        : 'No'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <label>
                                                                    Insurable
                                                                    Earnings:
                                                                </label>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <span>
                                                                    {revision.yearlyInsurableEarning
                                                                        ? `$ ${revision.yearlyInsurableEarning}`
                                                                        : '--'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr />
                                            </div>
                                        )
                                    )}
                                </div>
                            ) : (
                                <div>
                                    <div>
                                        <h5>Revised Salaries</h5>
                                    </div>

                                    <div className="no-records">
                                        No records found
                                    </div>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Jobinfo
